import { useState, useEffect } from 'react';
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// Icons
import { IoMdSettings } from "react-icons/io";
import { FaTrashAlt } from "react-icons/fa";

const WebstoreLinkCardComponent = ({ id, webstoreLink, handleEditWebstoreLinkItem, handleDeleteWebstoreLinkItem, totalItems }) => {

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    height: 296,
    margin: 10,
    backgroundColor: '#eeeeee',
    display: 'flex',
    alignItems: "center",
    borderRadius: 8,
    cursor: 'grab',
    overflow : 'hidden',
    transform: CSS.Transform.toString(transform),
    transition,
  };


  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <div style={{ display : 'flex', flexDirection : 'column', width : '100%' }}>
        <div style={{ display : 'flex', flexDirection : 'row', justifyContent : 'flex-start', alignItems : 'center' }}>
          <img style={{ height : 256, aspectRadio : 1.0, overflow : 'hidden', borderTopLeftRadius : 8, borderTopRightRadius : 8 }} src={ webstoreLink.imageUrl } />
          <div style={{ fontSize: 28, paddingLeft : 10 }}>{ webstoreLink.displayText }</div>
        </div>
        <div style={{ height : 40, backgroundColor : '#8d949e', paddingLeft: 10, paddingRight : 10, display : 'flex', alignItems : 'center', justifyContent : 'space-between', width : '100%' }}>
          <div style={{ color : 'white', fontSize: 18, fontWeight : 'bold' }}># { (parseInt(webstoreLink.orderId)+1) } / { totalItems } { webstoreLink.enrichedData.displayStatus }</div>
          <div style={{ display : 'flex', flexDirection : 'row', alignItems : 'center' }}>
            <div style={{ cursor : 'pointer' }} onClick={ () => { handleEditWebstoreLinkItem(webstoreLink); }}><IoMdSettings style={{ color : 'white', fontSize: 26, paddingTop : 4 }} /></div>
            <div style={{ cursor : 'pointer' }} onClick={ () => { handleDeleteWebstoreLinkItem(webstoreLink); }}><FaTrashAlt style={{ color : 'white', fontSize: 22, paddingTop : 4 }} /></div>
          </div>
        </div>
      </div>
    </div>
  );

  /**
  return (
    <div ref={ setNodeRef } style={ style } {...attributes} {...listeners}>
      <div style={{}}>
        <img style={{ height : 100 }} src={ webstoreLink.imageUrl } />
        { webstoreLink.displayText ? (
          <div style={{}}>{ webstoreLink.displayText }</div>
        ) : null }
      </div>
      <div style={{}}>
        <div style={{ color : 'white', fontSize: 18, fontWeight : 'bold' }}>{ webstoreLink.enrichedData.displayStatus }</div>
        <div style={{ display : 'flex', flexDirection : 'row', alignItems : 'center' }}>
          <div style={{ cursor : 'pointer' }} onClick={ () => { handleEditWebstoreLinkItem(webstoreLink); }}><IoMdSettings style={{ color : 'white', fontSize: 26, paddingTop : 4 }} /></div>
          <div style={{ cursor : 'pointer' }} onClick={ () => { handleDeleteWebstoreLinkItem(webstoreLink); }}><FaTrashAlt style={{ color : 'white', fontSize: 22, paddingTop : 4 }} /></div>
        </div>
      </div>
    </div>
  );
  **/

};

export default WebstoreLinkCardComponent;

